import React from "react";
import BurgerMenu from "../../svg/burgerMenu";
import MenuOpenX from "../../svg/menuOpen";

const TopHeaderMobile = ({ openMenu, setOpenMenu }) => {
  return (
    <div className="mobile-header">
      {openMenu ? (
        <button 
          className="mobile-menu" 
          onClick={() => setOpenMenu(false)}
          aria-label="Close navigation menu"
          aria-expanded="true"
        >
          <MenuOpenX />
        </button>
      ) : (
        <button 
          className="mobile-menu" 
          onClick={() => setOpenMenu(true)}
          aria-label="Open navigation menu"
          aria-expanded="false"
        >
          <BurgerMenu />
        </button>
      )}
    </div>
  );
};

export default TopHeaderMobile;
